import { useCallback, useEffect, useState } from 'react'
import {
  type ApiCbrRate,
  type ApiForexRate,
  type ApiSupplierRates,
  fetchCbrRate,
  fetchForexRate,
  fetchSupplierRates,
} from '@/fetcher'

export type MarketRates = {
  cbr: ApiCbrRate | null
  forex: ApiForexRate | null
  supplier: ApiSupplierRates | null
}

const emptyRates: MarketRates = {
  cbr: null,
  forex: null,
  supplier: null,
}

export const useMarketRates = (enabled: boolean) => {
  const [rates, setRates] = useState<MarketRates>(emptyRates)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const loadRates = useCallback(async () => {
    if (!enabled) return

    setIsLoading(true)
    setErrorMessage(null)

    const [cbr, forex, supplier] = await Promise.all([
      fetchCbrRate().catch(() => null),
      fetchForexRate().catch(() => null),
      fetchSupplierRates().catch(() => null),
    ])

    const nextRates = { cbr, forex, supplier }
    setRates(nextRates)
    if (!cbr && !forex && !supplier) {
      setErrorMessage('Курсы временно недоступны')
    }
    setIsLoading(false)
  }, [enabled])

  useEffect(() => {
    void loadRates()
  }, [loadRates])

  return { rates, isLoading, errorMessage, loadRates }
}
